
// Cache structure
export interface ImageCache {
  [key: string]: {
    url: string;
    expires: number;
  };
}

import { CACHE_DURATION } from './constants';

/**
 * Get an image from the cache if it exists and hasn't expired
 */
export const getFromCache = (key: string): string | null => {
  try {
    const cacheJson = localStorage.getItem('unsplashImageCache');
    if (!cacheJson) return null;
    
    const cache: ImageCache = JSON.parse(cacheJson);
    const cachedItem = cache[key];
    
    if (cachedItem && cachedItem.expires > Date.now()) {
      return cachedItem.url;
    }
    
    return null;
  } catch (error) {
    console.error('Error reading from cache:', error);
    return null;
  }
};

/**
 * Save an image to the cache
 */
export const saveToCache = (key: string, url: string): void => {
  try {
    const cacheJson = localStorage.getItem('unsplashImageCache');
    const cache: ImageCache = cacheJson ? JSON.parse(cacheJson) : {};
    
    cache[key] = {
      url,
      expires: Date.now() + CACHE_DURATION
    };
    
    localStorage.setItem('unsplashImageCache', JSON.stringify(cache));
  } catch (error) {
    console.error('Error saving to cache:', error);
  }
};
